import { Eye, LogOut } from 'lucide-react';
import { useAuth } from '../lib/auth';

// Unmistakable while a Super Admin is working inside someone else's account.
export const ImpersonationBanner = () => {
  const { user, stopImpersonation } = useAuth();
  const imp = user?.impersonated_by;
  if (!imp) return null;

  const leave = async () => {
    await stopImpersonation();
    window.close();
    window.location.assign('/login');
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="fixed bottom-0 left-0 right-0 z-[70] flex flex-wrap items-center justify-center gap-x-3 gap-y-1
                 border-t border-amber-400/40 bg-amber-500/95 px-4 py-2 text-amber-950 shadow-[0_-6px_24px_rgba(0,0,0,0.25)]"
    >
      <Eye size={15} className="shrink-0"/>
      <span className="text-sm font-semibold">
        You are using the app as {user.name || user.email}
      </span>
      <span className="text-xs opacity-80">
        ({String(user.role || '').replace('_', ' ')}) · everything you do here is recorded against {imp.name || imp.email}
      </span>
      <button
        onClick={leave}
        data-testid="impersonation-exit-btn"
        className="ml-1 inline-flex items-center gap-1.5 rounded-full bg-amber-950 px-3 py-1 text-xs font-semibold
                   text-amber-50 transition-colors hover:bg-amber-900"
      >
        <LogOut size={12}/> Return to my account
      </button>
    </div>
  );
};

export default ImpersonationBanner;
